import { createSelector } from '@reduxjs/toolkit';
import ms from 'ms';

import { GlobalState } from '@/redux/store';
import { emptySellerDetails } from '@/types/SellerDetails';
import { isEmpty } from '@/utils/isEmpty/isEmpty';

export const SELLER_DETAILS_CACHE_TIME = ms('30m');

const stateSelector = (state: GlobalState) => state;
const sellerDetailSlice = createSelector(stateSelector, (state) => state.sellerDetails);

const idSelector = (_: GlobalState, id: number) => id;

const byIdSelector = createSelector(sellerDetailSlice, (state) => state.byId);

const loadedSelector = createSelector(sellerDetailSlice, (state) => state.loaded);

const loadingSelector = createSelector(sellerDetailSlice, (state) => state.loading);

// takes in a (state, id) and returns the data
export const getSellerDetail = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || emptySellerDetails);
export const getSellerPhoneNumber = createSelector(getSellerDetail, ({ phoneNumber }) => phoneNumber || '');
export const getSellerDescription = createSelector(getSellerDetail, ({ description }) => description || '');
export const getSellerEmail = createSelector(getSellerDetail, ({ email }) => email || '');

// takes in a (state, id) and returns the load time
const getLoadTimeForSellerDetail = createSelector([loadedSelector, idSelector], (loaded, id) => loaded[id] || 0);

// takes in a (state, id) and returns the is loading
const isSellerDetailLoading = createSelector([loadingSelector, idSelector], (loading, id) => {
    return loading.indexOf(id) !== -1;
});

const shouldFetchSellerDetail = (state: GlobalState, sellerId: number) => {
    const data = getSellerDetail(state, sellerId);
    if (!isEmpty(data)) {
        const loaded = getLoadTimeForSellerDetail(state, sellerId);
        const time = Date.now();
        const diff = time - loaded;
        if (diff < SELLER_DETAILS_CACHE_TIME) {
            return false;
        }
    }
    const loading = isSellerDetailLoading(state, sellerId);
    return !loading;
};

export const whichSellerDetailsNeeded = (state: GlobalState, sellerIds: number[]) =>
    sellerIds.filter((sellerId) => shouldFetchSellerDetail(state, sellerId));
